import React from "react";
import type { ComponentProps, PartData } from "@enonic/react-components";
import Accordion from "/react4xp/components/shared/Accordion/Accordion";
import type { AccordionProps } from "./Accordion.d";

export const AccordionPart = (props: ComponentProps<PartData>) => {
  const data = (props.data as AccordionProps) ?? {};

  return data.listAccordion.length ? (
    <div className="container">
      <Accordion accordionBlocks={props.data} />
    </div>
  ) : (
    <p>Add some items!</p>
  );
};

export default AccordionPart;
